export default __webpack_public_path__ + "static/media/proffesor-alfredo-murado-rounded.e7e85063.png";